module.exports = "/_next/static/images/game-header-tournament-d9b9d782b712eff46c1b665d57e9a898.png";